import db from 'domains/db'
import { ref, push } from 'firebase/database'

export const createUID = () => {
  const uid = push(ref(db))
  return uid.key
}
